'use client';

import { useState, useEffect } from 'react';
import ContactHero from './ContactHero';
import ContactMethods from './ContactMethods';
import ContactForms from './ContactForms';
import ConsultationBooking from './ConsultationBooking';

interface ContactInteractiveProps {
  className?: string;
}

const ContactInteractive = ({ className = '' }: ContactInteractiveProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className={`min-h-screen bg-background ${className}`}>
        <div className="animate-pulse">
          <div className="h-96 bg-muted"></div>
          <div className="max-w-7xl mx-auto px-4 py-16 space-y-8">
            <div className="h-64 bg-muted rounded-lg"></div>
            <div className="h-96 bg-muted rounded-lg"></div>
            <div className="h-64 bg-muted rounded-lg"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen bg-background ${className}`}>
      <ContactHero />
      <ContactMethods />
      <ContactForms />
      <ConsultationBooking />
    </div>
  );
};

export default ContactInteractive;
